module.exports = __webpack_public_path__ + "img/IC1101_banner_ynw.5b813053.png";